export default __webpack_public_path__ + "static/media/b5.3441e9e0.png";